import { differenceInCalendarDays } from 'date-fns/differenceInCalendarDays';

import { isValid, parseDateWithFormat, parseISO } from 'lib/dates';

const DISPLAY_DATE_PATTERN = /^\d{2}\/\d{2}\/\d{4}$/;

export const parseCalendarDate = (value) => {
    if (!value) return null;

    if (value instanceof Date) return isValid(value) ? value : null;

    if (typeof value !== 'string') return null;

    const normalizedValue = value.trim();
    const parsedDate = DISPLAY_DATE_PATTERN.test(normalizedValue)
        ? parseDateWithFormat(normalizedValue, 'en-GB', 'dd/MM/yyyy')
        : parseISO(normalizedValue);

    return isValid(parsedDate) ? parsedDate : null;
};

export const getImplementationDeactivationInfo = (
    expectedDeactivationDate,
    currentDate = new Date(),
) => {
    const deactivationDate = parseCalendarDate(expectedDeactivationDate);
    const today = parseCalendarDate(currentDate);

    if (!deactivationDate || !today) {
        return {
            daysRemaining: null,
            isInactive: false,
            shouldShow: false,
        };
    }

    const daysRemaining = differenceInCalendarDays(deactivationDate, today);
    const isInactive = daysRemaining <= 0;

    return {
        daysRemaining,
        isInactive,
        shouldShow: daysRemaining <= 30,
    };
};
